/**
 * @Description 业务模式
 */

import { FC, } from 'react';

import { FormItemProps, SelectProps } from 'antd';
import V2FormSelect from '@/common/components/Form/V2FormSelect/V2FormSelect';
import { BusinessMode } from '@/common/components/business/ExpandStore/ts-config';

const FormBusinessMode:FC<{
  name: string;
  label?: string;
  rules?: any;
  placeholder?: string;
  selectConfig?: SelectProps;
  formConfig?: FormItemProps;
  required?: boolean;
  onChange?: (value: BusinessMode) => void;
}> = ({
  name,
  label,
  rules,
  placeholder,
  selectConfig,
  formConfig,
  required,
  onChange,
}) => {
  const options = [
    { label: '加盟模式', value: BusinessMode.Franchisee },
    { label: '直营模式', value: BusinessMode.Direct },
    { label: '联营模式', value: BusinessMode.Joint },
  ];

  return (
    <V2FormSelect
      required={required}
      name={name}
      label={label}
      options={options}
      rules={rules}
      placeholder={placeholder}
      config={{
        showSearch: true,
        ...selectConfig
      }}
      formItemConfig={formConfig}
      onChange={onChange}
    />
  );
};

export default FormBusinessMode;
